import React from "react";

/**
 * Inline-SVG иконки народного роадмапа Рублокса. Без эмодзи.
 * Все иконки 1em × 1em, stroke=currentColor.
 */

const COMMON = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

function Svg({ size = "1em", children }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...COMMON}
             style={{ verticalAlign: "-0.15em" }}>
            {children}
        </svg>
    );
}

/* ── секции главной ─────────────────────────────────────────────── */
export const PaletteIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M12 2a10 10 0 1 0 10 10c0-3-3-3-3-5s2-2 2-4-3-3-9-3z" />
        <circle cx="7.5"  cy="10.5" r="1.2" fill="currentColor" stroke="none" />
        <circle cx="12"   cy="6.5"  r="1.2" fill="currentColor" stroke="none" />
        <circle cx="16.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" />
        <circle cx="9"    cy="15"   r="1.2" fill="currentColor" stroke="none" />
    </Svg>
);

export const ConstructionIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M10 4l-6 16h16L14 4z" />
        <line x1="8"  y1="10" x2="16" y2="10" />
        <line x1="6.5" y1="15" x2="17.5" y2="15" />
    </Svg>
);

export const FireIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M12 2c1 3 5 5 5 10a5 5 0 1 1-10 0c0-2 1-3 1-5s2 2 4-5z" />
        <path d="M12 14c.5 1.5 2 2 2 4a2 2 0 1 1-4 0c0-1 1-1.5 1-2.5s.5 0 1-1.5z" />
    </Svg>
);

export const SparklesIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M12 3l1.5 4L17.5 8.5 13.5 10 12 14l-1.5-4L6.5 8.5 10.5 7z" />
        <path d="M18 14l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
        <path d="M5 16l.5 1.5 1.5.5-1.5.5L5 20l-.5-1.5L3 18l1.5-.5z" />
    </Svg>
);

export const CheckCircleIcon = ({ size }) => (
    <Svg size={size}>
        <circle cx="12" cy="12" r="9" />
        <polyline points="8,12.5 11,15.5 16,9.5" />
    </Svg>
);

/* ── базовые кнопки/счётчики ────────────────────────────────────── */
export const HeartIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </Svg>
);

export const CommentIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
    </Svg>
);

export const PlusIcon = ({ size }) => (
    <Svg size={size}>
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5"  y1="12" x2="19" y2="12" />
    </Svg>
);

export const ArrowRightIcon = ({ size }) => (
    <Svg size={size}>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="13,6 19,12 13,18" />
    </Svg>
);

export const ArrowLeftIcon = ({ size }) => (
    <Svg size={size}>
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="11,18 5,12 11,6" />
    </Svg>
);

export const AlertIcon = ({ size }) => (
    <Svg size={size}>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </Svg>
);

export const InboxIcon = ({ size }) => (
    <Svg size={size}>
        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
        <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </Svg>
);

/* ── иконки СТАТУСОВ (для StatusBadge) ──────────────────────────── */

/** Часики — на голосовании. */
export const ClockIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <circle cx="12" cy="12" r="9" />
        <polyline points="12,7 12,12 15,14" />
    </Svg>
);

/** Галочка — принята. */
export const CheckIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <polyline points="4,12 10,18 20,6" />
    </Svg>
);

/** Шестерёнка — в разработке. */
export const GearIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <circle cx="12" cy="12" r="3.2" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V21a2 2 0 1 1-4 0v-.08a1.7 1.7 0 0 0-1.11-1.55 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.55-1.04H3a2 2 0 1 1 0-4h.08a1.7 1.7 0 0 0 1.55-1.11 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h.04a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.08a1.7 1.7 0 0 0 1.04 1.55 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.04a1.7 1.7 0 0 0 1.55 1.04H21a2 2 0 1 1 0 4h-.08a1.7 1.7 0 0 0-1.55 1.04z" />
    </Svg>
);

/** Глаз — на тестировании. */
export const EyeIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </Svg>
);

/** Звезда — сделано (как награда). */
export const StarIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <polygon points="12,2 15,9 22,9.5 17,14.5 18.5,21 12,17.5 5.5,21 7,14.5 2,9.5 9,9" />
    </Svg>
);

/** Крест — отклонена. */
export const XIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <line x1="6" y1="6"  x2="18" y2="18" />
        <line x1="18" y1="6" x2="6"  y2="18" />
    </Svg>
);

/** Снежинка — заморожена. */
export const SnowIcon = ({ size = 12 }) => (
    <Svg size={size}>
        <line x1="12" y1="3"  x2="12" y2="21" />
        <line x1="3"  y1="12" x2="21" y2="12" />
        <line x1="5"  y1="5"  x2="19" y2="19" />
        <line x1="19" y1="5"  x2="5"  y2="19" />
    </Svg>
);

/** Молния — для hero «За идею в игре — 50 алмазов». */
export const BoltIcon = ({ size }) => (
    <Svg size={size}>
        <polygon points="13,2 4,14 11,14 10,22 19,10 12,10" />
    </Svg>
);

/** Алмаз — счётчик алмазов в hero. */
export const DiamondIcon = ({ size }) => (
    <Svg size={size}>
        <polygon points="6,3 18,3 22,9 12,22 2,9" />
        <line x1="2"  y1="9" x2="22" y2="9" />
        <line x1="6"  y1="3" x2="12" y2="22" />
        <line x1="18" y1="3" x2="12" y2="22" />
    </Svg>
);
